/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PatchOperation { 
    operation?: PatchOperation.OperationEnum;
    path?: string;
    value?: object;
}
export namespace PatchOperation {
    export type OperationEnum = 'add' | 'remove' | 'replace';
    export const OperationEnum = {
        Add: 'add' as OperationEnum,
        Remove: 'remove' as OperationEnum,
        Replace: 'replace' as OperationEnum
    };
}


